const modalsBtn = document.querySelectorAll("a[href^='#modal-'], button[class^='modal-']");
const modals = document.querySelectorAll("dialog[id^='modal-']");


const dFix = () => {
  document.body.style.top = `-${window.scrollY}px`;
  document.body.style.position = 'fixed';
  document.body.style.width = '100%';
}

const dAuto = () => {
  const positionScrollY = document.body.style.top ? document.body.style.top : `-${window.scrollY}px`;
  document.body.style.position = '';
  document.body.style.top = '';
  document.body.style.width = '';
  window.scrollTo(0, parseInt(positionScrollY || '0') * -1);
}

modalsBtn.forEach(modalBtn => {
  
  modalBtn.addEventListener('click', () => {
    let id;
    switch (modalBtn.tagName) {
      case 'A':
        id = modalBtn.getAttribute('href').substring(1);
        break;
      case 'BUTTON':
        const classList = modalBtn.getAttribute('class').split(' ');
        id = classList.find(c => c.startsWith('modal-'));
        break;
      default:
        console.error('Unexpected tag name:', modalBtn.tagName);
        return;
    }
    const dialogElement = document.getElementById(id);
    if (dialogElement) {
      dialogElement.showModal();
      dialogElement.setAttribute('aria-modal', 'true');
      dFix();
    } else
      console.error('Dialog element not found for ID:', id);
  })
});

modals.forEach(modal => {
  modal.addEventListener('click', (e) => {
    const dialog = e.currentTarget;
    const isClickOnBackDrop = e.target === dialog;
    if (isClickOnBackDrop) {
      dialog.close();
      dAuto();
    }
  });

const closeButton = modal.querySelector('.modal__close');
if (closeButton) {
  // Function to handle closing
  const handleClose = () => {
    modal.close();
    modal.setAttribute('aria-modal', 'false');
    dAuto();
  };

  // Add click event listener
  closeButton.addEventListener('click', handleClose);

  // Add keyboard event listener for Enter and Space keys
  closeButton.addEventListener('keydown', (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault(); // Prevent default behavior (like scrolling for Space)
      handleClose();
    }
  });
}
});

document.addEventListener('keydown', (event) => {
  if (event.key === "Escape") {
    dAuto();
  }
});

document.addEventListener('DOMContentLoaded', () => {

  const dialog = document.getElementById('feedback-thanks');
  if (dialog) {
    const observer = new MutationObserver((mutationsList) => {
      mutationsList.forEach((mutation) => {
        if (mutation.attributeName === 'open' && !dialog.hasAttribute('open')) {
          window.location.href = '/';
        }
      });
    });
    observer.observe(dialog, { attributes: true });
  } else {
    console.error('Element with id "feedback-thanks" not found in DOM');
  }
});